import { FeatureToggleClientService } from 'feature-toggle-client';
const AdsBuyingEnabled = 'ads-buying-display';
export class AdsBuyingFeatures {
    static isAdsBuyingEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(AdsBuyingEnabled);
    }
}
